<li ngbDropdown class="nav-item dropdown-notifications navbar-dropdown dropdown me-3 me-xl-1">
  <a ngbDropdownToggle class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" aria-expanded="false">
    <i class="ti ti-bell ti-md fs-4"></i>
    <span *ngIf="notificationCount>0" class="badge bg-danger rounded-pill badge-notifications">{{notificationCount}}</span>
  </a>
  <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end notification-menu py-0">
    <li class="dropdown-menu-header border-bottom">
      <div class="dropdown-header d-flex align-items-center py-3">
        <h5 class="text-body mb-0 me-auto">Notification</h5>
        <a href="javascript:void(0)" *ngIf="notifications.length !== 0" (click)="markAllAsRead()" class="dropdown-notifications-all text-body" >
          <i class="ti ti-mail-opened fs-4" placement="top" ngbTooltip="Mark all as read" autoClose="inside" container="body"></i>
        </a>
      </div>
    </li>
    <ng-scrollbar autoHeightDisabled="false">
      <li class="dropdown-notifications-list  scrollable-container">
        <ul class="list-group list-group-flush">
          <li ngbDropdownItem *ngFor="let notif of notifications" class="dropdown-item list-group-item list-group-item-action dropdown-notifications-item" >
            <button type="button" class="notification-row" (click)="detailNotificationGroup(notif)">
              <div
                class="notification-icon"
                [style.color]="getNotificationColor(notif)"
                [style.background]="getNotificationIconBackground(notif)">
                <i [ngClass]="getNotificationIconClass(notif)"></i>
              </div>

              <div class="notification-content">
                <h6 class="notification-title" [title]="notif.subject">{{notif.subject}}</h6>
                <p class="notification-message" [title]="notif.description">{{notif.description}}</p>
                <div class="notification-meta">
                  <span class="notification-type">{{notif.notification_type}}</span>
                  <small class="notification-time">{{getTimeEclipse(notif.timestamp)}}</small>
                </div>
              </div>

              <div class="notification-actions">
                <div class="dropdown-notifications-read">
                  <span *ngIf="!notif.read" class="badge badge-dot"></span>
                </div>
              </div>
            </button>
          </li>
        </ul>
      </li>
    </ng-scrollbar>
    <li *ngIf="this.notifications.length<=0" class="dropdown-notifications-list">
      <div class="d-flex align-items-center justify-content-center p-5">
        <p>No notifications</p>
      </div>
    </li>
    <li class="dropdown-menu-footer border-top">
      <a [routerLink]="['/app/alarms/notifications/list']" href="javascript:void(0)"
        class="dropdown-item d-flex justify-content-center text-primary p-2 h-px-40 mb-1 align-items-center">
        View all notifications
      </a>
    </li>
  </ul>
</li>
